import script from "./InvestmentCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestmentCard.vue?vue&type=script&setup=true&lang=ts"

import "./InvestmentCard.vue?vue&type=style&index=0&id=54296864&lang=scss"

const __exports__ = script;

export default __exports__